var React = require('react');

function FontsElement (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"12","width":"22","height":"22","fill":"#262556","key":0}),React.createElement("rect",{"x":"46","y":"22","width":"22","height":"22","fill":"#75D5D2","key":1}),React.createElement("rect",{"x":"46","width":"22","height":"22","fill":"#75D5D2","key":2}),React.createElement("rect",{"y":"44","width":"22","height":"22","fill":"#B58CFF","key":3})]);
}

FontsElement.defaultProps = {"width":"68","height":"66","viewBox":"0 0 68 66","fill":"none"};

module.exports = FontsElement;

FontsElement.default = FontsElement;
